export const CRM_NAV_DOCK_PIN_DRAG_TYPE = 'application/x-pulse-nav-dock-pin';

export function buildNavDockDragPayload(item) {
  if (!item?.to) return '';
  return JSON.stringify({
    path: String(item.to),
    label: String(item.label || ''),
    icon: String(item.icon || '')
  });
}

export function parseNavDockDragPayload(dataTransfer) {
  if (!dataTransfer) return null;
  const typed = dataTransfer.getData(CRM_NAV_DOCK_PIN_DRAG_TYPE);
  const raw = typed || dataTransfer.getData('text/plain');
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    const path = String(parsed?.path || '').trim();
    if (!path.startsWith('/')) return null;
    return {
      path,
      label: String(parsed?.label || '').trim(),
      icon: String(parsed?.icon || '').trim()
    };
  } catch {
    const path = String(raw || '').trim();
    if (!path.startsWith('/')) return null;
    return { path, label: '', icon: '' };
  }
}

export function canAcceptNavDockDrag(dataTransfer) {
  if (!dataTransfer) return false;
  if (Array.from(dataTransfer.types || []).includes(CRM_NAV_DOCK_PIN_DRAG_TYPE)) return true;
  const plain = dataTransfer.getData('text/plain');
  return String(plain || '').trim().startsWith('/');
}
